import { Component, OnInit, OnChanges, ChangeDetectorRef, SimpleChanges, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
// import { Subscription } from 'rxjs';
import { of, throwError, Subscription, EMPTY } from 'rxjs';
// import { debounceTime, take } from 'rxjs/operators';
import { catchError, debounceTime, finalize, switchMap, take } from 'rxjs/operators';
import { SessionModalService } from '../../../service/session-modal.service';
import { TarjetasService, consultaAbtResp, ConsultaAbtServicio } from 'src/app/service/tarjetas.service';


@Component({
  selector: 'app-movimientos',
  templateUrl: './movimientos.component.html',
  styleUrls: ['./movimientos.component.scss'],
})
export class MovimientosComponent implements OnInit, OnDestroy {
  cardSelected: any;
  filter: any;
  errorMensaje: any;
  count = 0;
  idUsuario: any;
  transacciones: Subscription;
  tarjeta: Subscription;
  gettingData: boolean = false;
  movimientos: ConsultaAbtServicio = {
    mensaje: '',
    estado: null,
    saldo: undefined,
    estadoVigencia: '',
    listaTransacciones: []
  }

  constructor(private router: Router, private tarjetas: TarjetasService, private cd: ChangeDetectorRef, private sessionModal: SessionModalService) {
    this.movimientos.mensaje = '';
    const idUsuarioLs = JSON.parse(localStorage.getItem('sesionPocae') || '{}').idUsuario || null;
    this.idUsuario = idUsuarioLs;
  }

  private transaccionesSub?: Subscription;
  private tarjetaSub?: Subscription;


  ngOnInit() {
    // Cuando cambie la tarjeta, cancelamos petición previa y hacemos nueva
    this.tarjetaSub = this.tarjetas.selectedCard
      .pipe(
        // prevenir múltiples llamadas rápidas
        debounceTime(200),
        switchMap(tarjeta => {
          this.cardSelected = tarjeta;
          this.filter = 30;
          // devolvemos el observable de la petición
          return this.fetchTransacciones();
        })
      )
      .subscribe({
        next: (res: consultaAbtResp) => {
          this.movimientos = res.servicio;
        }
      });
  }
private fetchTransacciones() {
  const ksi = localStorage.getItem('KSI');
  if (!ksi || !this.cardSelected) return EMPTY;

  const idUsuario = Number(localStorage.getItem('idUsuario') || JSON.parse(localStorage.getItem('sesionPocae') || '{}')?.idUsuario || 0);

  const json = {
    sesion: {
      sIdSesion: ksi,
      nIdUsuarioWeb: idUsuario,
      nIdEmpresa:  5,
      sHost: '127.0.0.1'
    },
    numExterno: this.cardSelected,
    numeroDias: Number(this.filter)
  };

  if (this.gettingData) return EMPTY;

  this.gettingData = true;
  return this.tarjetas.getTransaccionesAbt(json).pipe(
    take(1),
    catchError(err => {
      if (err?.error?.estado?.mensajeError) {
        this.errorMensaje = err.error.estado.mensajeError;
      } else {
        this.errorMensaje = 'Error al obtener movimientos. Intente de nuevo.';
      }
      return throwError(() => err);
    }),
    finalize(() => this.gettingData = false)
  );
}



  changeFilter(value: string) {
    this.filter = Number(value);
    this.getData();
  }

   getData() {
    this.transaccionesSub = this.fetchTransacciones().subscribe({
      next: (res: consultaAbtResp | null) => {
        if (res) this.movimientos = res.servicio;
      },
      error: (err) => {
        this.errorMensaje = this.errorMensaje || 'Error al obtener datos';
      }
    });
  }

  monto(data: any) {
    return (data.MONTO_ABONO == 0) ? data.MONTO_DESCUENTO : data.MONTO_ABONO;
  }

  comproboTrx(data) {
    if (data.codigotipotrx != 15) {
      return data.estacion
    }

    if (data.servicio == null) {
      return data.estacion
    }

    return data.servicio
  }
  comproboVehi(data) {
    if (data.codigotipotrx != 15) {
      return null
    }

    if (data.servicio == null) {
      return null
    }

    return data.estacion
  }

  ngOnDestroy() {
    if (this.transaccionesSub) {
      this.transaccionesSub.unsubscribe();
    }
    if (this.tarjetaSub) {
      this.tarjetaSub.unsubscribe();
    }
  }
}


